/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Style_Preset_Save_ConfirmInputs */

const en_image_export_style_preset_save_confirm = /** @type {(inputs: Image_Export_Style_Preset_Save_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Preset`)
};

const fr_image_export_style_preset_save_confirm = /** @type {(inputs: Image_Export_Style_Preset_Save_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer le prereglage`)
};

const de_image_export_style_preset_save_confirm = /** @type {(inputs: Image_Export_Style_Preset_Save_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreinstellung speichern`)
};

const it_image_export_style_preset_save_confirm = /** @type {(inputs: Image_Export_Style_Preset_Save_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva preimpostazione`)
};

const ru_image_export_style_preset_save_confirm = /** @type {(inputs: Image_Export_Style_Preset_Save_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить предустановку`)
};

const es_image_export_style_preset_save_confirm = /** @type {(inputs: Image_Export_Style_Preset_Save_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar ajuste preestablecido`)
};

const zh_cn2_image_export_style_preset_save_confirm = /** @type {(inputs: Image_Export_Style_Preset_Save_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存预设`)
};

const ja_image_export_style_preset_save_confirm = /** @type {(inputs: Image_Export_Style_Preset_Save_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットを保存`)
};

const hi_image_export_style_preset_save_confirm = /** @type {(inputs: Image_Export_Style_Preset_Save_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट सहेजें`)
};

const pt_pt2_image_export_style_preset_save_confirm = /** @type {(inputs: Image_Export_Style_Preset_Save_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar predefinição`)
};

/**
* | output |
* | --- |
* | "Save Preset" |
*
* @param {Image_Export_Style_Preset_Save_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_style_preset_save_confirm = /** @type {((inputs?: Image_Export_Style_Preset_Save_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Style_Preset_Save_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_style_preset_save_confirm(inputs)
	if (locale === "de") return de_image_export_style_preset_save_confirm(inputs)
	if (locale === "it") return it_image_export_style_preset_save_confirm(inputs)
	if (locale === "ru") return ru_image_export_style_preset_save_confirm(inputs)
	if (locale === "es") return es_image_export_style_preset_save_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_style_preset_save_confirm(inputs)
	if (locale === "ja") return ja_image_export_style_preset_save_confirm(inputs)
	if (locale === "hi") return hi_image_export_style_preset_save_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_style_preset_save_confirm(inputs)
	return en_image_export_style_preset_save_confirm(inputs)
});